//

import { gql } from '@apollo/client';

export default gql`
    query processGeotagButtonQuery($id: ID!) {
        result: process(id: $id) {
            id
            name
            _geoJson
        }
    }
`;
